import { render, staticRenderFns } from "./UIRating.vue?vue&type=template&id=0a3a7290&"
import script from "./UIRating.vue?vue&type=script&lang=js&"
export * from "./UIRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports